/**
 * Default copy of the Filter (English). A page passes its own language through
 * the `labels` prop — any subset; the rest falls back to these. Counted
 * strings are functions so a language can choose its own plural forms.
 */
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

const DEFAULT_LABELS = {
  /** Mobile trigger, the drawer title and the desktop group name */
  filters: 'Filters',
  /** Desktop trigger shown when the attributes do not all fit (maxInline) */
  allFilters: 'All filters',
  sort: 'Sort by',
  clear: 'Clear',
  clearAll: 'Clear all',
  close: 'Close',
  search: 'Search',
  noMatches: 'No matches',
  showAll: (n) => `Show all (${n})`,
  showLess: 'Show less',
  /** The range fields */
  from: 'From',
  to: 'To',
  /** Accessible names of the range thumbs, given the attribute label */
  rangeMin: (label) => `${label}, minimum`,
  rangeMax: (label) => `${label}, maximum`,
  /** Drawer button without a result count (no countResults) */
  apply: 'Show products',
  showResults: (n) => `Show ${plural(n, 'product', 'products')}`,
  noResults: 'No products',
  /** The polite live region */
  results: (n) => plural(n, 'product', 'products'),
  activeFilters: 'Active filters',
  removeChip: (label) => `Remove filter: ${label}`,
};

export default DEFAULT_LABELS;
